var site = site || {};

(function($) {
  'use strict';

  var blobCanvasServices = function($element, options) {
	this.$el = $element;
	this.renderIID = -1;
	this.resizeIID = -1;
	this.startTS = new Date().getTime();

	this.options = $.extend({
	  color: 'purpleServices',
	  colorPeriod: 500,
	  pulsePeriod: 5000,
	  mouseHalo: 20,
	  wanderPoint: 0.5,
	  wanderControl: 1,
	  links: false
	}, options || {});
	
	this.initialize();
  };

  blobCanvasServices.prototype.initialize = function() {
    var self = this;
	  
    this.colorSet = {
      'purpleServices': ['#3e324a', '#45279b', '#574b97', '#935fcc', '#bbbcdd']
    };
	  
    this.nodeCount = 7;
    this.loopCount = 5;

	this.resize();  
    this.rendererStart();
    this.render();

    this.$el
      .on('mouseenter', function(){
        self.$el.on('mousemove', function(e){ self.mouseMove(e); });
      })
      .on('mouseleave', function(){
        self.$el.off('mousemove');
        self.nodesTarget = $.extend(true, [], self.nodesOriginal );
      });
	  
	  $(window).resize(function() {
		  clearTimeout(self.resizeIID);
		  self.resizeIID = setTimeout(function(){
			  self.resize();
		  }, 250);
	  });

    };
  
  blobCanvasServices.prototype.resize = function() {
    var factor = this.$el.height() / 256;

    this.size = { width: Math.round(380 * factor), height: this.$el.height() };
	
	// Width and height have to be set as attributes, so need to remove and recreated canvas
	if (this.$canvas && this.$canvas.length) { this.$canvas.remove(); }
    this.$canvas = $('<canvas width="'+ this.size.width +'" height="'+ this.size.height +'"></canvas>').appendTo(this.$el);
	this.ctx = this.$canvas.get(0).getContext("2d");
    this.ctx.lineWidth = 1;
	  
	$('.blob-links',this.$el).css({width: this.size.width});
	  
	if (this.$el.width() < this.size.width ) { 
		var newMargin = Math.round((this.$el.width() - this.size.width) / 2);
		this.$canvas.css({marginLeft: newMargin});
		$('.blob-links',this.$el).css({marginLeft: newMargin});
	} else {
		this.$canvas.css({marginLeft: 'auto'});
		$('.blob-links',this.$el).css({marginLeft: 'auto'});
	}

    this.options.wanderPointDev = this.options.wanderPoint * factor;
    this.options.wanderControlDev = this.options.wanderControl * factor;
    this.options.mouseHaloDev = this.options.mouseHalo * factor * this.options.mouseHalo * factor;
    
    this.nodesOriginal = [
      { x:61.9 * factor, y:209.2 * factor, cx:81.7 * factor, cy:185.5 * factor }, //0
      { x:110.0 * factor, y:132.3 * factor, cx:139.0 * factor, cy:110.7 * factor },
      { x:190.0 * factor, y:103.3 * factor, cx:218.3 * factor, cy:102.0 * factor }, //2
      { x:277.7 * factor, y:132.2 * factor, cx:311.5 * factor, cy:153.7 * factor },
      { x:339.0 * factor, y:196.2 * factor, cx:350.5 * factor, cy:223.0 * factor }, //4
      { x:357.2 * factor, y:256 * factor, cx:357.2 * factor, cy:256 * factor },
      { x:23.0 * factor, y:256 * factor, cx:23.0 * factor, cy:256 * factor }, // 6

      { x:78.3 * factor, y:212.6 * factor, cx:95.5 * factor, cy:189.2 * factor },
      { x:118.5 * factor, y:149.0 * factor, cx:143.0 * factor, cy:136.0 * factor },
      { x:190.0 * factor, y:132.3 * factor, cx:214.3 * factor, cy:133.0 * factor },
      { x:264.8 * factor, y:156.7 * factor, cx:290.8 * factor, cy:176.3 * factor },
      { x:312.3 * factor, y:215.7 * factor, cx:321.3 * factor, cy:235.0 * factor },
      { x:323.9 * factor, y:256 * factor, cx:323.9 * factor, cy:256 * factor },
      { x:46.3 * factor, y:256 * factor, cx:46.3 * factor, cy:256 * factor },

      { x:97.3 * factor, y:221.7 * factor, cx:104.3 * factor, cy:200.2 * factor },
      { x:128.6 * factor, y:171.4 * factor, cx:142.5 * factor, cy:160 * factor },
      { x:190.0 * factor, y:159.0 * factor, cx:213.0 * factor, cy:160 * factor },
      { x:253.7 * factor, y:170.8 * factor, cx:269.3 * factor, cy:179.8 * factor },
      { x:293.8 * factor, y:218.0 * factor, cx:303.5 * factor, cy:238.5 * factor },
      { x:308.7 * factor, y:256 * factor, cx:308.7 * factor, cy:256 * factor },
      { x:76.5 * factor, y:256 * factor, cx:76.5 * factor, cy:256 * factor },

      { x:128.9 * factor, y:234.9 * factor, cx:130.4 * factor, cy:223.9 * factor },
      { x:143.2 * factor, y:199.2 * factor, cx:153.5 * factor, cy:191.3 * factor },
      { x:190.0 * factor, y:187.5 * factor, cx:207.5 * factor, cy:188.3 * factor },
      { x:251.3 * factor, y:204.0 * factor, cx:273.3 * factor, cy:214.5 * factor },
      { x:285.5 * factor, y:236.3 * factor, cx:290.8 * factor, cy:250.3 * factor },
      { x:290.7 * factor, y:256 * factor, cx:290.7 * factor, cy:225666 * factor },
      { x:123.2 * factor, y:256 * factor, cx:123.2 * factor, cy:256 * factor },

      { x:146.6 * factor, y:239.2 * factor, cx:148.7 * factor, cy:232.0 * factor },
      { x:163.8 * factor, y:221.7 * factor, cx:171.2 * factor, cy:217.7 * factor },
      { x:190.0 * factor, y:213.8 * factor, cx:201.7 * factor, cy:213.0 * factor },
      { x:224.3 * factor, y:219.8 * factor, cx:234.0 * factor, cy:223.2 * factor },
      { x:245.5 * factor, y:236.5 * factor, cx:251.2 * factor, cy:244.3 * factor },
      { x:256.5 * factor, y:256 * factor, cx:256.5 * factor, cy:256 * factor },
      { x:146.3 * factor, y:256 * factor, cx:146.3 * factor, cy:256 * factor }
    ];
	
	this.nodeOrigin = { x:190 * factor, y:246 * factor };

    this.nodesTarget = $.extend(true, [], this.nodesOriginal );
    this.nodes = $.extend(true, [], this.nodesOriginal );

    };

  blobCanvasServices.prototype.mouseMove = function(e) {
    var i, ilen,
	  canvasOffset = this.$canvas.offset(),
      mouse = { x:e.pageX - canvasOffset.left, y:e.pageY - canvasOffset.top },
      delta = { x:0, y:0, cx:0, cy:0 },
      factor = 1,
      sqDist = 0,
      node, nodeOriginal,
      mouseHalo = this.options.mouseHaloDev;

    for (i=0,ilen=this.nodesTarget.length; i<ilen; i++) {
      node = this.nodesTarget[i];
      nodeOriginal = this.nodesOriginal[i];

      delta.x = nodeOriginal.x - mouse.x;
      delta.y = nodeOriginal.y - mouse.y;
      delta.cx = nodeOriginal.cx - mouse.x;
      delta.cy = nodeOriginal.cy - mouse.y;

      sqDist = (delta.x * delta.x) + (delta.y * delta.y);
      factor = (mouseHalo > sqDist)?1:mouseHalo / sqDist;

      node.x = nodeOriginal.x + (factor * delta.x);
      node.y = nodeOriginal.y + (factor * delta.y);

      sqDist = (delta.cx * delta.cx) + (delta.cy * delta.cy);
      factor = (mouseHalo > sqDist)?1:mouseHalo / sqDist;

      node.cx = nodeOriginal.cx + (factor * delta.cx);
      node.cy = nodeOriginal.cy + (factor * delta.cy);
    }

  };

  blobCanvasServices.prototype.rendererStart = function() {
    var self = this;
    clearInterval(this.renderIID);
    this.renderIID = setInterval(function(){ self.render(); }, 50);
  };

  blobCanvasServices.prototype.rendererStop = function() {
    clearInterval(this.renderIID);
  };

  blobCanvasServices.prototype.render = function() {
    var i, ilen,
      newTS = new Date().getTime(),
      timeDelta = newTS - this.startTS,
      angle = ( timeDelta % this.options.pulsePeriod ) * 2*Math.PI / this.options.pulsePeriod,
      sin = Math.sin( angle ),
      cos = Math.cos( angle ),
      sin2 = Math.sin( angle + (Math.PI*0.5) ),
      cos2 = Math.cos( angle + (Math.PI*0.5) ),
      sinC = (sin * this.options.wanderControlDev),
      sinP = (sin * this.options.wanderPointDev),
      cosC = (cos * this.options.wanderControlDev),
      cosP = (cos * this.options.wanderPointDev),
      sinC2 = (sin2 * this.options.wanderControlDev),
      sinP2 = (sin2 * this.options.wanderPointDev),
      cosC2 = (cos2 * this.options.wanderControlDev),
      cosP2 = (cos2 * this.options.wanderPointDev),
      node, nodeTarget;
    this._clear();

    for (i=0,ilen=this.nodes.length; i<ilen; i++) {
      node = this.nodes[i];
      nodeTarget = this.nodesTarget[i];

	  if ( i%this.nodeCount >= 5 ) {
		  node.x = node.x + (( nodeTarget.x - node.x ) / 4) + sinP;
          node.y = this.nodesOriginal[i].y;
		  continue;
	  }	
		
      switch ( i%4 ) {
        case 0:
          node.x = node.x + (( nodeTarget.x - node.x ) / 4) + sinP;
          node.y = node.y + (( nodeTarget.y - node.y ) / 4) + cosP;
          node.cx = node.cx + (( nodeTarget.cx - node.cx ) / 4) + sinC;
          node.cy = node.cy + (( nodeTarget.cy - node.cy ) / 4) + cosC;
          break;
        case 2:
          node.x = node.x + (( nodeTarget.x - node.x ) / 4) - sinP;
          node.y = node.y + (( nodeTarget.y - node.y ) / 4) - cosP;
          node.cx = node.cx + (( nodeTarget.cx - node.cx ) / 4) - sinC;
          node.cy = node.cy + (( nodeTarget.cy - node.cy ) / 4) - cosC;
          break;
        case 3:
          node.x = node.x + (( nodeTarget.x - node.x ) / 4) + sinP2;
          node.y = node.y + (( nodeTarget.y - node.y ) / 4) + cosP2;
          node.cx = node.cx + (( nodeTarget.cx - node.cx ) / 4) + sinC2;
          node.cy = node.cy + (( nodeTarget.cy - node.cy ) / 4) + cosC2;
          break;
        case 1:
          node.x = node.x + (( nodeTarget.x - node.x ) / 4) - sinP2;
          node.y = node.y + (( nodeTarget.y - node.y ) / 4) - cosP2;
          node.cx = node.cx + (( nodeTarget.cx - node.cx ) / 4) - sinC2;
          node.cy = node.cy + (( nodeTarget.cy - node.cy ) / 4) - cosC2;
          break;
      }

    }

    for (i=0,ilen=this.loopCount; i<ilen; i++) {
      this._drawloop( i * this.nodeCount, this.colorSet[this.options.color][i] );
    }
	  
	if (this.options.links.length > 0) {
		for (i=0,ilen=this.loopCount-1; i<ilen; i++) {
			this.options.links.filter( ':eq('+i+')' ).css({left: (this.nodes[(i*7)+2].x + this.nodes[(i*7)+9].x) / 2, top: (this.nodes[(i*7)+2].y + this.nodes[(i*7)+9].y) / 2 });
		}
		this.options.links.filter( ':eq('+(this.loopCount-1)+')' ).css({left: (this.nodes[(this.loopCount*7)-5].x + this.nodeOrigin.x) / 2, top: (this.nodes[(this.loopCount*7)-5].y + this.nodeOrigin.y) / 2 });
	}

    /*
	//for (i=0,ilen=this.nodes.length; i<ilen; i++) {
    for (i=(7*2),ilen=(7*5); i<ilen; i++) {
      this._drawdiamond( this.nodes[i] );
    } 
	*/

  };

  blobCanvasServices.prototype._clear = function() {
    this.ctx.clearRect( 0, 0, this.size.width, this.size.height );
  };

  blobCanvasServices.prototype._drawloop = function( offset, color ) {
    var p0, p1, p2, pn, pl,
      i, ilen;

    p0 = this.nodes[offset];

    this.ctx.beginPath();
    this.ctx.moveTo(p0.x, p0.y);
    for (i=offset,ilen=this.nodeCount+offset-3; i<ilen; i++) {
      p1 = this.nodes[i];
      p2 = this.nodes[i+1];
      this.ctx.bezierCurveTo(p1.cx,p1.cy, (p2.x*2)-p2.cx,(p2.y*2)-p2.cy, p2.x, p2.y);
    }
	pn = this.nodes[i+1]; // Bottom right
    pl = this.nodes[i+2]; // Bottom left
	this.ctx.bezierCurveTo(p2.cx,p2.cy, pn.x,pn.y-10, pn.x, pn.y);
	this.ctx.lineTo(pl.x,pl.y);
	this.ctx.bezierCurveTo(pl.x,pl.y-10, (p0.x*2)-p0.cx,(p0.y*2)-p0.cy, p0.x, p0.y);
	  
    this.ctx.closePath();
    this.ctx.fillStyle = color;
    this.ctx.shadowColor = 'rgba(0,0,0,0.1)';
    this.ctx.shadowBlur = 64;
    this.ctx.fill();

    this.ctx.shadowColor = '#000000';
    this.ctx.shadowBlur = 0;

  };

  blobCanvasServices.prototype._drawdiamond = function(p) {
    // Used for DEV only
    this.ctx.beginPath();
    this.ctx.moveTo(p.x - (p.cx - p.x), p.y - (p.cy - p.y));
    this.ctx.lineTo(p.cx, p.cy);
    this.ctx.strokeStyle = 'rgba(0,0,0,0.5)';
    this.ctx.stroke();

    this.ctx.beginPath();
    this.ctx.moveTo(p.x, p.y+5);
    this.ctx.lineTo(p.x+5, p.y);
    this.ctx.lineTo(p.x, p.y-5);
    this.ctx.lineTo(p.x-5, p.y);
    this.ctx.closePath();
    this.ctx.fillStyle = '#000000';
    this.ctx.fill();

    this.ctx.beginPath();
    this.ctx.moveTo(p.cx, p.cy+5);
    this.ctx.lineTo(p.cx+5, p.cy);
    this.ctx.lineTo(p.cx, p.cy-5);
    this.ctx.lineTo(p.cx-5, p.cy);
    this.ctx.closePath();
    this.ctx.fillStyle = '#660000';
    this.ctx.fill();
  };

    site.blobCanvasServices = blobCanvasServices;
})(jQuery);
